export default __webpack_public_path__ + "static/media/coding-background.f936bd03.jpg";